import React from 'react';
import { FaReact, FaNodeJs, FaVuejs, FaLaravel, FaDatabase, FaAws, FaDocker } from 'react-icons/fa';
import { SiMongodb, SiMysql } from 'react-icons/si';

export const technologies = [
  { name: "React", icon: <FaReact /> },
  { name: "Node.js", icon: <FaNodeJs /> },
  { name: "Vue.js", icon: <FaVuejs /> },
  { name: "Laravel", icon: <FaLaravel /> },
  { name: "MongoDB", icon: <SiMongodb /> },
  { name: "MySQL", icon: <SiMysql /> },
  { name: "AWS", icon: <FaAws /> },
  { name: "Docker", icon: <FaDocker /> }
];